var map = {
	"./logo1.png": 765,
	"./logo2.png": 766,
	"./logo3.png": 767,
	"./logo4.png": 768,
	"./logo5.png": 769,
	"./logo6.png": 770,
	"./logo7.png": 771,
	"./logo8.png": 772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;